export * from '@taqueria/protocol/out/types/Settings';
export type { t } from '@taqueria/protocol/out/types/Settings';
